import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import WarningMessage from '@kurtosys/ksys-app-components/dist/components/message/WarningMessage';

export default InjectedStyledComponent(WarningMessage, 'app', ['warningMessage']);